import React, { Component } from "react";
import { t } from "i18next";
import { connect } from "react-redux";

import cx from "classnames";
import s from "./poweredBy.scss";

export class PoweredBy extends Component {
  render() {
    const { company, className, supportLink, isInSidebar } = this.props;

    if (company && supportLink) {
      return (
        <div className={cx(className, s.poweredBy, { [s.isInSidebar]: isInSidebar })}>
          <span>powered by Qboxmail</span>{" "}
          <span>
            {t("customizations.collaboration")}{" "}
            <a target="_blank" href={supportLink}>
              {company}
            </a>
          </span>
        </div>
      );
    }

    if (company) {
      return (
        <div className={cx(className, s.poweredBy, { [s.isInSidebar]: isInSidebar })}>
          <span>powered by Qboxmail</span>{" "}
          <span>
            {t("customizations.collaboration")} <b>{company}</b>
          </span>
        </div>
      );
    }

    if (!company) {
      return (
        <div className={cx(className, s.poweredBy, { [s.isInSidebar]: isInSidebar })}>
          <span>powered by Qboxmail</span>
        </div>
      );
    }
  }
}

const mapStateToProps = state => ({
  company: state.ui.company,
  supportLink: state.ui.supportLink
});

export default connect(mapStateToProps)(PoweredBy);
